import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { suppressNonCriticalWarnings } from './utils/suppressWarnings';
import { initGA } from './utils/analytics';
import { logAppStart } from './utils/firebaseAnalytics';

// 抑制非關鍵警告
suppressNonCriticalWarnings();

// 初始化Google Analytics
initGA();

// 初始化Firebase Analytics
logAppStart();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);
